<div class="custom-container user-list-container">
  <!-- <mat-icon color="primary" class="back-arrow" [routerLink]="'/dashboardAdmin'">arrow_back</mat-icon> -->
<mat-card>
  <mat-card-content>
<h1>Usuarios</h1>
<generic-table 
    [columnHeader]="columnHeader" 
    [service]="usercatalogService" 
    [controllerName]="controllerName"
    [hasInactives]="hasInactives"
    [hasEditables]="hasEditables"
    [hasDeletables]="hasDeletables"
    [filterOptions]="filterOptions"
    [catalogPaginationRequest]="catalogPaginationRequest"
    >
    </generic-table>
    
  </mat-card-content>
</mat-card>
</div>